export const SelectionStatus = ({
  selectedCount,
  totalCount: pageSize,
}: {
  selectedCount: number
  totalCount: number
}) => {
  return (
    <div className="text-sm text-muted-foreground">
      {selectedCount} of {pageSize} row{selectedCount === 1 ? '' : 's'} selected.
    </div>
  )
}
